import { render, staticRenderFns } from "./IFRSDataExtraction.vue?vue&type=template&id=a28e197c&"
import script from "./IFRSDataExtraction.vue?vue&type=script&lang=js&"
export * from "./IFRSDataExtraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports